import PropTypes from 'prop-types';
export var optionShape = PropTypes.shape({
    value: PropTypes.any,
    label: PropTypes.node,
});
export default PropTypes.arrayOf(optionShape);
